import React from 'react';

import { Typography, Box } from '@mui/material';

const Sejaum: React.FC = () => {
  return (
    <div className="sejaum-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Seja um Bnei Noach
      </Typography>
      <Box>
        <Typography variant="body1">
          Página "Seja um" em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Sejaum; 